import { add, dinero, toDecimal, toUnits } from 'dinero.js';
import { useIntl } from 'react-intl';
import { displayCurrencyWithSymbol, getDineroCurrency } from 'utils/currency';

export const useIntlHook = () => {
  const intl = useIntl();

  const formatCurrencyToLocale = (amount: number, currencyCode: string, isW2UI?: boolean) => {
    if (!Number.isInteger(amount)) {
      console.warn(`Amount ${amount} is not an integer`);
      return '';
    }

    const STABLECOIN_CODES = ['USDC', 'USDT'];
    if (STABLECOIN_CODES.includes(currencyCode?.toUpperCase())) {
      const value = amount / 100;
      return `${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currencyCode.toUpperCase()}`;
    }

    const currencyDisplayString = displayCurrencyWithSymbol(amount, currencyCode, false);
    const value = parseFloat(currencyDisplayString);
    const amountWithCurrency = intl.formatNumber(value, { style: 'currency', currency: currencyCode });
    if (isW2UI) {
      return amountWithCurrency.replace('US$', '$');
    }
    return amountWithCurrency;
  };

  const addAmounts = (amounts: number[], currencyCode = 'USD') => {
    const dineroCurrency = getDineroCurrency(currencyCode);

    const d = amounts.reduce(
      (acc, amount) => {
        return add(acc, dinero({ amount: amount, currency: dineroCurrency }));
      },
      dinero({ amount: 0, currency: dineroCurrency }),
    );

    const amount =
      dineroCurrency.exponent === 2
        ? toDecimal(d, ({ value }) => `${value}`)
        : toUnits(d, ({ value }) => `${value[0]}`);
    const value = parseFloat(amount);
    return intl.formatNumber(value, { style: 'currency', currency: currencyCode });
  };

  return {
    formatCurrencyToLocale,
    addAmounts,
  };
};

export default useIntlHook;
